import React from "react";

import PageLayout from "../../layouts/PageLayout";

function index(props) {
  const appName = "Login";

  return <PageLayout appName={appName}></PageLayout>;
}

export default index;
